import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import {
  DELETE_PROCUREMENT_REQUEST,
  GET_ALL_PROCUREMENT_LIST_REQUEST,
} from "../../../../../../Utils/Constant";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import {ItemsListColumns } from "./ItemsListColumns";
import { useNavigate } from "react-router-dom";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";

const ItemsListTable = ({ data }) => {
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("name");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

   const {
      loading,
      addProcurement,
      updateProcurement,
      deleteProcurement,
    } = useSelector((state) => state.procurement);
    useEffect(() => {
      dispatch({
        type: GET_ALL_PROCUREMENT_LIST_REQUEST,
      });
    }, [
      dispatch,
      addProcurement,
      updateProcurement,
      deleteProcurement,
    ]);

  const handleDelete = (selectData) => {
    setSelectedUser(selectData);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (data?.items?.length) {
      const transformed = data?.items?.map((data) => ({
        item_name: data?.item?.name || "N/A",
        quantity: data.quantity || 0,
        unit: data.item.unit || "N/A",
        purpose: data.purpose || " ",
        unit_price: data.unit_price || 0,
        total: data.total || 0,
        item_total_cost: data.item_total_cost || 0,
        // items: (
        //   <>
        //     <span
        //       className="btn"
        //       onClick={() => {
        //         navigate(`/procurements/${data?.id}`);
        //       }}
        //     >
        //       View
        //     </span>
        //   </>
        // ),
        // actions: (
        //   <>
        //     <button
        //       className="btn"
        //       data-toggle="modal"
        //       data-target="#deleteGuest"
        //       onClick={() => handleDelete(data)}
        //     >
        //       <i className="bi bi-trash text-danger"></i>
        //     </button>
        //     <button
        //       data-bs-toggle="offcanvas"
        //       // data-bs-target="#add-procurement"
        //       // aria-controls="add-procurement"
        //       className="btn"
        //       onClick={() => setSelectedDepartment(data)}
        //     >
        //       <i className="bi bi-pencil text-primary"></i>
        //     </button>
        //   </>
        // ),
      }));

      setCategoryData(transformed);
    } else {
      setCategoryData([]);
    }
  }, [openMenuId]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = data?.items?.length || 0;
  const totalPages = 1;

  const confirmDelete = () => {
    dispatch({
      type: DELETE_PROCUREMENT_REQUEST,
      payload: { id: selectedUser?.id },
    });
    setShowDeleteModal(false);
  };

  return (
    <div>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="category"
      />
      <DataTable
        columns={ItemsListColumns}
        data={categoryData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      <ConfirmationATM
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedUser("");
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete ${selectedUser?.name} ?`}
      />
    </div>
  );
};

export default ItemsListTable;
